module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-classic-1475.ffffb6de.svg";